// Snow Products — Blanco Premium JS v6

// — Formato de precio —
(function () {
  var re = /^€\s*([\d,.]+)(?:\s+EUR)?$/;
  function fix(el) {
    if (el.childElementCount === 0) {
      var t = el.textContent.trim(), m = t.match(re);
      if (m) el.textContent = m[1] + '€';
    }
  }
  function fixAll() { document.querySelectorAll('.money, .price-item').forEach(fix); }
  if (window.Shopify) window.Shopify.money_format = '{{amount_with_comma_separator}}€';
  document.addEventListener('DOMContentLoaded', fixAll);
  var debounce;
  new MutationObserver(function () { clearTimeout(debounce); debounce = setTimeout(fixAll, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', function () {

  var isProduct = window.location.pathname.indexOf('/products/') !== -1;

  // — Trust bar —
  if (isProduct) {
    var form = document.querySelector('.product-form, form[action="/cart/add"]');
    if (form) {
      var bar = document.createElement('div');
      bar.className = 'sp-trust-bar';
      bar.innerHTML = ['Envío gratis en pedidos +100€','Devolución gratuita en pedidos superiores a 100€','Pago 100% seguro','Expertos en nieve y moda']
        .map(function(t){return '<span class="sp-trust-item">'+t+'</span>';}).join('');
      form.parentNode.insertBefore(bar, form.nextSibling);
    }
  }

  // — Floating finder tab (Encuentra tu equipo) — all pages —
  (function(){
    var CSS=
      '#sp-finder{position:fixed;right:0;top:50%;transform:translateY(-50%);z-index:9980;display:flex;align-items:center;}'
      +'#sp-finder-tab{background:#111;color:#fff;border:none;cursor:pointer;padding:0;display:flex;align-items:center;border-radius:8px 0 0 8px;overflow:hidden;transition:width .25s ease;width:48px;height:56px;text-decoration:none;}'
      +'#sp-finder-tab:hover,#sp-finder-tab.expanded{width:200px;}'
      +'#sp-finder-icon{width:48px;height:56px;flex-shrink:0;display:flex;align-items:center;justify-content:center;}'
      +'#sp-finder-text{white-space:nowrap;overflow:hidden;font-size:.82rem;font-weight:700;letter-spacing:.01em;padding-right:14px;opacity:0;transition:opacity .2s .1s;}'
      +'#sp-finder-tab:hover #sp-finder-text,#sp-finder-tab.expanded #sp-finder-text{opacity:1;}';
    var s=document.createElement('style');s.textContent=CSS;document.head.appendChild(s);
    var w=document.createElement('div');w.id='sp-finder';
    w.innerHTML='<a id="sp-finder-tab" href="/pages/encuentra-tu-equipo" title="Encuentra tu equipo ideal">'
      +'<span id="sp-finder-icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/></svg></span>'
      +'<span id="sp-finder-text">¿Cuál es tu equipo?</span>'
      +'</a>';
    document.body.appendChild(w);
    var key='sp-finder-seen';
    if(!sessionStorage.getItem(key)){
      sessionStorage.setItem(key,'1');
      var tab=w.querySelector('#sp-finder-tab');
      setTimeout(function(){
        tab.classList.add('expanded');
        setTimeout(function(){tab.classList.remove('expanded');},2200);
      },1500);
    }
  })();

  // — "Retiro disponible" → "Recogida disponible" —
  function fixPickup() {
    document.querySelectorAll('pickup-availability, [class*="pickup"]').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/Retiro disponible/g, 'Recogida disponible')
        .replace(/Retiro no disponible/g, 'Recogida no disponible');
    });
  }
  fixPickup();
  setTimeout(fixPickup, 1500);

  // — Barra progreso envío —
  function updateShippingBar() {
    var cart = window.Shopify && window.Shopify.cart ? window.Shopify.cart : null;
    if (!cart) return;
    var total = (cart.total_price || 0) / 100, pct = Math.min(total / 100 * 100, 100);
    var fill = document.querySelector('.sp-shipping-fill'), msg = document.querySelector('.sp-shipping-msg');
    if (fill) fill.style.width = pct + '%';
    if (msg) msg.textContent = total >= 100 ? '¡Envío gratis conseguido!' : 'Te faltan ' + (100 - total).toFixed(2) + '€ para envío gratis';
  }
  var cartEl = document.querySelector('cart-drawer, .cart__items, [id="cart"]');
  if (cartEl) {
    var prog = document.createElement('div');
    prog.innerHTML = '<div class="sp-shipping-progress"><div class="sp-shipping-fill"></div></div><p class="sp-shipping-msg"></p>';
    cartEl.prepend(prog);
    updateShippingBar();
    document.addEventListener('cart:updated', updateShippingBar);
  }

  // — Sticky ATC móvil —
  if (isProduct && window.innerWidth <= 749) {
    var atc = document.querySelector('.product-form__submit');
    if (atc) {
      var sticky = document.createElement('div');
      sticky.className = 'sp-sticky-atc';
      var btn = document.createElement('button');
      btn.textContent = atc.textContent.trim() || 'Agregar al carrito';
      btn.onclick = function () { atc.click(); };
      sticky.appendChild(btn);
      document.body.appendChild(sticky);
    }
  }

  // — Blog filter activo —
  document.querySelectorAll('.sp-blog-filter a').forEach(function (a) {
    if (window.location.pathname.indexOf(a.getAttribute('href')) !== -1) a.classList.add('active');
  });

  // — Cargar comparador en páginas de producto —
  if (isProduct && !document.getElementById('cmp-overlay')) {
    var existing = document.querySelector('script[src*="product-compare.js"]');
    if (!existing) {
      var ref = document.querySelector('script[src*="/assets/"]');
      if (ref) {
        var base = ref.src.replace(/\/assets\/.*$/, '/assets/');
        var cmpScript = document.createElement('script');
        cmpScript.src = base + 'product-compare.js';
        cmpScript.defer = true;
        document.head.appendChild(cmpScript);
      }
    }
  }

});

// — In-stock sizes badge + ordenación preventa —
(function() {
  'use strict';
  function renderBadge(card, sizes) {
    if (!sizes || sizes.length === 0) return;
    var preorder = card.querySelector('.card__badge .badge--preorder');
    if (!preorder) return;
    var inner = card.querySelector('.card__inner');
    if (!inner) return;
    if (inner.querySelector('.card__instock-badge')) return;
    var div = document.createElement('div');
    div.className = 'card__instock-badge';
    var header = document.createElement('div');
    header.className = 'card__instock-header';
    header.textContent = 'EN STOCK';
    div.appendChild(header);
    var chipsDiv = document.createElement('div');
    chipsDiv.className = 'card__instock-chips';
    sizes.forEach(function(s) {
      var span = document.createElement('span');
      span.className = 'card__instock-chip';
      span.textContent = s;
      chipsDiv.appendChild(span);
    });
    div.appendChild(chipsDiv);
    inner.appendChild(div);
  }
  function getHandle(el) {
    var a = el.querySelector('a.full-unstyled-link');
    if (!a) return null;
    var match = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return match ? match[1] : null;
  }
  function sortPreventaGrid(data) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    Array.prototype.forEach.call(grid.children, function(item) {
      var handle = getHandle(item);
      var isPreorder = item.querySelector('.badge--preorder');
      if (!isPreorder || !handle) return;
      var productData = data[handle] || {};
      var hasStock = Object.keys(productData).some(function(k) { return productData[k] && productData[k].length > 0; });
      if (hasStock) item.style.order = '-1';
    });
  }
  function init() {
    var data = window.spInstockData || {};
    sortPreventaGrid(data);
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      var preorder = card.querySelector('.card__badge .badge--preorder');
      if (!preorder) return;
      var handle = getHandle(card);
      if (!handle) return;
      var productData = data[handle];
      if (!productData) return;
      var cardColor = card.getAttribute('data-color');
      var sizes;
      if (cardColor && productData[cardColor]) {
        sizes = productData[cardColor];
      } else if (!cardColor) {
        sizes = [];
        var seen = {};
        Object.keys(productData).forEach(function(k) {
          (productData[k] || []).forEach(function(s) {
            if (!seen[s]) { seen[s] = 1; sizes.push(s); }
          });
        });
      }
      renderBadge(card, sizes);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

// — Disponibles primero en colecciones —
(function() {
  var isCollection = document.body && document.body.classList.contains('template-collection');
  if (!isCollection) {
    var main = document.querySelector('main[data-template]');
    isCollection = main && main.dataset.template === 'collection';
  }
  if (!isCollection) return;

  function sortAvailableFirst(grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    items.sort(function(a, b) {
      var aCard = a.querySelector('[data-available]');
      var bCard = b.querySelector('[data-available]');
      var aAvail = aCard && aCard.dataset.available === 'false' ? 0 : 1;
      var bAvail = bCard && bCard.dataset.available === 'false' ? 0 : 1;
      return bAvail - aAvail;
    });
    items.forEach(function(item) { grid.appendChild(item); });
  }

  function setup() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    sortAvailableFirst(grid);
    new MutationObserver(function() { sortAvailableFirst(grid); }).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

// — Flash Sale Banner permanente (Oferta Flash 24h) —
(function () {
  var COLLECTION_URL = '/collections/oferta-flash-24h';
  var STORAGE_KEY = 'sp-flash-dismissed-v2';
  var dismissedAt = sessionStorage.getItem(STORAGE_KEY);
  // Re-show after midnight even if dismissed
  if (dismissedAt) {
    var today = new Date().toDateString();
    if (dismissedAt === today) return;
  }

  // Calculate tonight 23:59:59 Spain time (Europe/Madrid), DST-safe
  function getEndOfDayMadrid() {
    var now = new Date();
    var madridNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
    var endOfDay = new Date(madridNow);
    endOfDay.setHours(23, 59, 59, 0);
    if (endOfDay <= madridNow) endOfDay.setDate(endOfDay.getDate() + 1);
    return new Date(now.getTime() + (endOfDay - madridNow));
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatCountdown(end) {
    var diff = Math.max(0, end - Date.now());
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function inject() {
    var css = [
      '#sp-flash{position:fixed;top:0;left:0;right:0;z-index:10000;background:linear-gradient(90deg,#c00 0%,#e60 100%);color:#fff;display:flex;align-items:center;justify-content:center;gap:12px;padding:14px 52px 14px 16px;font-size:1rem;font-weight:700;letter-spacing:.03em;box-shadow:0 2px 8px rgba(0,0,0,.3);font-family:inherit;}',
      '#sp-flash-bolt{font-size:1.05rem;animation:sp-pulse 1s ease-in-out infinite alternate;flex-shrink:0;}',
      '@keyframes sp-pulse{from{opacity:.7;transform:scale(.9)}to{opacity:1;transform:scale(1.12)}}',
      '#sp-flash-link{color:#fff;text-decoration:none;display:flex;align-items:center;gap:12px;flex-wrap:wrap;justify-content:center;}',
      '#sp-flash-label{white-space:nowrap;}',
      '#sp-flash-cta{background:rgba(255,255,255,.18);padding:2px 10px;border-radius:4px;white-space:nowrap;transition:background .15s;}',
      '#sp-flash-link:hover #sp-flash-cta{background:rgba(255,255,255,.32);}',
      '#sp-flash-countdown{background:rgba(0,0,0,.22);padding:2px 10px;border-radius:4px;font-variant-numeric:tabular-nums;font-size:.9rem;letter-spacing:.05em;min-width:72px;text-align:center;white-space:nowrap;}',
      '#sp-flash-close{position:absolute;right:14px;top:50%;transform:translateY(-50%);background:none;border:none;color:rgba(255,255,255,.85);cursor:pointer;font-size:1.15rem;line-height:1;padding:4px 6px;}',
      '#sp-flash-close:hover{color:#fff;}',
      'body.sp-flash-open{padding-top:62px !important;}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'sp-flash-style';
    style.textContent = css;
    document.head.appendChild(style);

    var endTime = getEndOfDayMadrid();

    var bar = document.createElement('div');
    bar.id = 'sp-flash';
    bar.setAttribute('role', 'banner');
    bar.innerHTML =
      '<span id="sp-flash-bolt">⚡</span>' +
      '<a id="sp-flash-link" href="' + COLLECTION_URL + '">' +
        '<span id="sp-flash-label">OFERTA FLASH 24H &nbsp;·&nbsp; 10% en productos seleccionados</span>' +
        '<span id="sp-flash-countdown">' + formatCountdown(endTime) + '</span>' +
        '<span id="sp-flash-cta">Ver oferta →</span>' +
      '</a>' +
      '<button id="sp-flash-close" aria-label="Cerrar">✕</button>';

    document.body.prepend(bar);
    document.body.classList.add('sp-flash-open');

    document.getElementById('sp-flash-close').addEventListener('click', function () {
      bar.remove();
      document.body.classList.remove('sp-flash-open');
      sessionStorage.setItem(STORAGE_KEY, new Date().toDateString());
    });

    var timer = setInterval(function () {
      // Recalculate end time at midnight rollover
      var now = Date.now();
      if (now >= endTime) endTime = getEndOfDayMadrid();
      var el = document.getElementById('sp-flash-countdown');
      if (!el) { clearInterval(timer); return; }
      el.textContent = formatCountdown(endTime);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
